export default __webpack_public_path__ + "static/media/slide-3.f6b4318c.png";